import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import video_2 from '../assets/videos/2.mp4';
export default function Immersive() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5); // 新增：倒计时状态（初始5秒）

  useEffect(() => {
    const timer = setInterval(() => {
      if (countdown > 1) {
        setCountdown(prev => prev - 1); // 每秒减1
      } else {
        // window.location.href = 'https://serenama.my.canva.site/dagndpb4opi'; // 倒计时结束跳转
        navigate('/mainstreet')
        clearInterval(timer); // 清理定时器
      }
    }, 1000);

    return () => clearInterval(timer); // 组件卸载时清理定时器
  }, [countdown]);
  return (
    <div className="relative">
      <video
        src={video_2}
        className="w-full h-auto"  // 铺满容器宽度，高度自适应
        autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
        loop                      // 循环播放
        muted                     // 静音（避免自动播放被浏览器阻止）
        playsInline               // iOS 设备内联播放（非全屏）
        controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
      />
      <div className="top-[19vw] w-auto absolute left-[15%] transform -translate-x-1/2">
        <div className="flex flex-row items-left gap-[1.5vw]">
          <span className="text-[3.1vw] vertical-text-ml">墨林迷踪</span>
          <span className="text-[1.3vw] rotate-90 " style={{
            marginTop: '3.5vw',
            letterSpacing: '0.1vw'
          }}>Inkwood Odyssey</span>
        </div>
      </div>
      <div className="top-[16vw] w-auto absolute left-[24%] transform -translate-x-1/2">
        <div className="flex flex-row items-left gap-[1.5vw]">
          <span className="text-[1.8vw] vertical-text-ml">—项元汴的鉴藏故事</span>
          <span className="text-[1vw] rotate-90 " style={{
            marginTop: '3vw',
            letterSpacing: '0.1vw'
          }}>Story of Yuanbian Xiang's collection</span>
        </div>
      </div>
      <div className="top-[13vw] absolute left-[23%] w-[68%] z-[9999] text-center">
        <div className="flex flex-col">
          <span className="text-[#ffffff] text-[1.6vw] text-center">项元汴鉴藏的艺术品来源较多，主要有以下五点：</span>
          <span className="text-[#ffffff] text-[1vw] text-center">According to historical records, the sources of Xiang Yuanbian's collected artworks can be categorized into five primary origins.</span>
          <span className="text-[#ffffff] text-[1vw] text-center mt-[2.5vw] leading-[1.5vw]">其一，在本地收购外地商人兜售的古董，比如郭五游和王复元便是与项元汴做交易的两个代表性商人。陈继儒《妮古录》载：“子昂亭林碑，其真迹曾粘村民屋壁，王野宾买之以售项氏。”</span>
          <span className="text-[#ffffff] text-[1vw] text-center leading-[1.5vw]">其二，与友人进行书画交易。项元汴曾从安国手里购得王羲之的《每思帖》，“墨林主人项元汴用价五十金得于无锡安氏，时隆庆三年八月朔日”</span>
          <span className="text-[#ffffff] text-[1vw] text-center leading-[1.5vw]">其三，占有充当典当品的书画。项元汴开有当铺，一些急需用钱的人常常以所藏书画前来质钱。据载，“宋高宗手书龙王勅，向在三塔寺，寺僧信大源质项子京家”。</span>
          <span className="text-[#ffffff] text-[1vw] text-center leading-[1.5vw]">其四，项元汴与友人的相互馈赠。比如：1564年，丰坊为项元汴庆生作《临右军二帖扇面》；1578 年，文嘉为项元汴庆生作《山水图》。</span>
          <span className="text-[#ffffff] text-[1vw] text-center leading-[1.5vw]">其五，从集市、店铺购买藏品。明中叶，江浙一带的古玩艺术市场已初具规模，不仅出现了固定的店肆、古董铺，还出现了带有集市性质的设摊交易。</span>
          <span className="text-[#ffffff] text-[1vw] text-center mt-[2.5vw] leading-[1.5vw]">Firstly, the local acquisition of antiques peddled by foreign merchants, such as Guo Wuyou and Wang Fuyuan are the two representative merchants with whom Xiang Yuanbian made transactions. Secondly, he traded paintings and calligraphy with his friends. Thirdly, the possession of paintings and calligraphy as pawned goods. Xiang Yuanbian had a pawnshop, and some people in need of money often came to pawn their paintings and calligraphy. Fourth, Xiang Yuanbian and his friends gave gifts to each other. Fifth, buying collections from bazaars and shops. In the middle of the Ming Dynasty, the antique art market in Jiangsu and Zhejiang had begun to take shape, and there were not only fixed shops and antique shops, but also stalls with the nature of the bazaar.
          </span>
        </div>
      </div>
      <div className="bottom-[2vw] absolute left-[80%] w-auto z-[9999] text-left">
        <div className="flex flex-col">
          <span className="text-[#ffffff] text-[1.2vw]">
            游戏式沉浸体验场景加载中... {countdown}s {/* 动态显示剩余秒数 */}
          </span>
        </div>
      </div>
    </div>
  )
}